export default __webpack_public_path__ + "static/media/phonerotary-1.28b64461.svg";